'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import Rollbar from 'rollbar';
import { clientConfig } from 'src/rollbar';
import { ResetPage } from './reset';
import { isChunkLoadError } from 'src/components/ErrorHandlers/isChunkLoadError';

// Simple chunk error fallback for global error (no theme provider available)
function SimpleChunkErrorFallback() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  const handleRefreshNow = _temp3;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "2rem",
      fontFamily: "system-ui, -apple-system, sans-serif",
      backgroundColor: "#f5f5f5"
    };
    t2 = {
      backgroundColor: "white",
      padding: "2rem",
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      textAlign: "center",
      maxWidth: "500px"
    };
    t3 = <div style={{
      fontSize: "3rem",
      marginBottom: "1rem"
    }}>🔄</div>;
    t4 = <h1 style={{
      color: "#333",
      marginBottom: "1rem"
    }}>App Update Available</h1>;
    t5 = <p style={{
      color: "#666",
      marginBottom: "2rem",
      lineHeight: "1.5"
    }}>A new version of the app has been deployed. To ensure you have the latest features and avoid any issues, the page will refresh automatically in a few seconds.</p>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div style={t1}><div style={t2}>{t3}{t4}{t5}<button onClick={handleRefreshNow} onFocus={_temp4} onBlur={_temp5} onMouseOver={_temp6} onMouseOut={_temp7} style={{
          backgroundColor: "#0070f3",
          color: "white",
          border: "none",
          padding: "0.75rem 1.5rem",
          borderRadius: "4px",
          fontSize: "1rem",
          cursor: "pointer",
          transition: "background-color 0.2s"
        }}>Refresh Now</button></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp7(e_2) {
  return e_2.currentTarget.style.backgroundColor = "#0070f3";
}
function _temp6(e_1) {
  return e_1.currentTarget.style.backgroundColor = "#0051cc";
}
function _temp5(e_0) {
  return e_0.currentTarget.style.backgroundColor = "#0070f3";
}
function _temp4(e) {
  return e.currentTarget.style.backgroundColor = "#0051cc";
}
function _temp3() {
  window.location.reload();
}
function _temp2() {
  const timer = setTimeout(_temp, 10000);
  return () => clearTimeout(timer);
}
function _temp() {
  window.location.reload();
}
export default function GlobalError(t0) {
  const $ = _c(6);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      const rollbar = new Rollbar(clientConfig);
      if (isChunkLoadError(error)) {
        rollbar.error("Chunk Load Error - Next.js Global Error Boundary", error, {
          userAgent: navigator.userAgent,
          url: window.location.href,
          timestamp: Date.now()
        });
      } else {
        rollbar.error(error);
      }
      const handleUnhandledRejection = event => {
        const rejectionError = event.reason;
        if (isChunkLoadError(rejectionError)) {
          console.warn("Chunk load error detected:", rejectionError);
          rollbar.warning("Chunk Load Error - Unhandled Rejection", rejectionError, {
            userAgent: navigator.userAgent,
            url: window.location.href,
            timestamp: Date.now()
          });
          event.preventDefault();
          setTimeout(_temp8, 1000);
        }
      };
      window.addEventListener("unhandledrejection", handleUnhandledRejection);
      return () => {
        window.removeEventListener("unhandledrejection", handleUnhandledRejection);
      };
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (isChunkLoadError(error)) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <html lang="en"><head><title>App Update Available</title><meta name="viewport" content="width=device-width, initial-scale=1" /></head><body><SimpleChunkErrorFallback /></body></html>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== reset) {
    t3 = <html lang="en"><body><ResetPage reset={reset} /></body></html>;
    $[4] = reset;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp8() {
  window.location.reload();
}